<template>
  <div
    class="relative inline-block cursor-pointer"
    @mouseover="showTooltip = true"
    @mouseleave="showTooltip = false"
    ref="tooltipContainer"
  >
    <slot></slot>

    <div
      v-if="showTooltip"
      :class="tooltipPosition"
      class="absolute z-10 text-black text-xs rounded py-2 px-4 w-64 shadow-lg"
      :style="{ backgroundColor: '#f8f9fa' }"
    >
      {{ tooltip }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";

const showTooltip = ref(false);
const tooltipContainer = ref<HTMLElement | null>(null);
const tooltipPosition = ref("bottom-0 mt-2");

defineProps({
  tooltip: {
    type: String,
    required: true,
  },
});

const updateTooltipPosition = () => {
  if (tooltipContainer.value) {
    const rect = tooltipContainer.value.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    if (rect.bottom + 150 > viewportHeight) {
      tooltipPosition.value = "bottom-full mb-2";
    } else {
      tooltipPosition.value = "top-full mt-2";
    }
  }
};

watch(showTooltip, (newValue) => {
  if (newValue) {
    updateTooltipPosition();
  }
});

onMounted(() => {
  window.addEventListener("resize", updateTooltipPosition);
});
</script>

<style scoped>
.shadow-lg {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.bottom-full {
  bottom: 100%;
}

.top-full {
  top: 100%;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mt-2 {
  margin-top: 0.5rem;
}
</style>
